var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm._t("prepend"), _c('div', {
    staticClass: "page__title"
  }, [_vm._v("上傳發票照片")]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("上傳照片")]), _c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function change($event) {
        return _vm.loadImage($event.target.files[0]);
      }
    }
  }), _vm.v$.image.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請上傳發票照片 ")]) : _vm._e()]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("發票號碼")]), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-3 align-self-start"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.alphabetic_letter,
      expression: "alphabetic_letter"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.alphabetic_letter.$error
    },
    attrs: {
      "maxlength": "2",
      "readonly": ""
    },
    domProps: {
      "value": _vm.alphabetic_letter
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.alphabetic_letter = $event.target.value;
      }
    }
  }), _vm.v$.alphabetic_letter.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入正確發票字軌 ")]) : _vm._e()]), _c('span', {
    staticClass: "col-1 text-center align-self-start"
  }, [_vm._v("-")]), _c('div', {
    staticClass: "col-8 align-self-start"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.number,
      expression: "number"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.number.$error
    },
    attrs: {
      "maxlength": "8",
      "readonly": ""
    },
    domProps: {
      "value": _vm.number
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value;
      }
    }
  }), _vm.v$.number.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入正確發票號碼 ")]) : _vm._e()])]), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("須包含英文，例：SH-87654321")])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("開立日期")]), _c('datepicker', {
    staticClass: "field__input py-0",
    class: {
      invalid: _vm.v$.invoice_at.$error
    },
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "disabled": _vm.dateUploadSuccess
    },
    model: {
      value: _vm.invoice_at,
      callback: function callback($$v) {
        _vm.invoice_at = $$v;
      },
      expression: "invoice_at"
    }
  }), _vm.v$.invoice_at.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入開立日期 ")]) : _vm._e()], 1), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("隨機碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.random_number,
      expression: "random_number"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.random_number.$error
    },
    attrs: {
      "maxlength": "4",
      "readonly": _vm.randomNumberUploadSuccess
    },
    domProps: {
      "value": _vm.random_number
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.random_number = $event.target.value;
      }
    }
  }), _vm.v$.random_number.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入發票隨機碼 ")]) : _vm._e()])])], 2), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送出")])], 1), _c('ImageResizer', {
    ref: "imageResizer"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }